<template>
  <div class="dataTableContainer">
    <div class="outline">
      <section class="content">
        <div class="scrollTop">
          <ul ref="scrollTop">
            <li v-for="(item, index) in tableHeadX" :key="index" @click="selectCol(index)">
              <span>{{ item }}</span>
            </li>
          </ul>
        </div>
        <div class="scrollLeft">
          <ul ref="scrollLeft">
            <li v-for="(item, index) in tableHeadY" :key="index" @click="selectRow(index)">
              <span>{{ item }}</span>
            </li>
          </ul>
        </div>
        <div class="scrollTable" @scroll="scrollTableHandle" ref="scrollTable">
          <table>
            <tbody>
              <tr v-for="(trItem, trIndex) in tableData.data" :key="'tr-' + trIndex">
                <td
                  :class="
                    trIndex === select.row && tdIndex === select.col
                      ? 'select cell'
                      : trIndex === editing.row && tdIndex === editing.col
                      ? 'editing cell'
                      : 'cell'
                  "
                  :data-id="trIndex.toString() + '-' + tdIndex.toString()"
                  v-for="(tdItem, tdIndex) in trItem.td"
                  :key="'td-' + tdIndex"
                  @dblclick="editingTd(trIndex, tdIndex, tdItem)"
                  @click="selectTd(trIndex, tdIndex)"
                >
                  <input
                    v-if="editing.row === trIndex && editing.col === tdIndex"
                    v-focus
                    class="data-editor"
                    @change="getCurrentInputValHandle(tableData.data[trIndex].td[tdIndex], trIndex, tdIndex)"
                    v-model="tableData.data[trIndex].td[tdIndex]"
                  />
                  <span v-else class="value-viewer">{{ tdItem }}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="selectArea">
          <div :class="selectRow_Col" :style="{ top: `${selectRow_top}px`, left: `${selectCol_left}px` }">
            <el-tooltip :content="delete_content" :placement="delete_placement">
              <span class="deleteIcon" @click="deleteArea">
                <i class="icon-portal-minus"></i>
              </span>
            </el-tooltip>
          </div>
        </div>
      </section>
      <div class="topLeft"></div>
    </div>
  </div>
</template>
<script>
import { _throttle } from "utils/index"

export default {
  name: "bar-series-data",
  props: {
    headerData: {
      type: Array
    },
    listData: {
      type: Array
    },
    options: {
      type: Object
    }
  },
  data() {
    return {
      this1: this,
      tableHeadX: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T"],
      tableHeadY: [],
      tableData: {
        data: []
      },
      select: { row: null, col: null },
      editing: { row: null, col: null },
      tableX: [],
      tableY: [],
      interval: 3,
      selectRow_Col: "",
      select_index: 0,
      selectRow_top: 0,
      selectCol_left: 0,
      delete_content: "",
      delete_placement: ""
    }
  },
  comments: {},
  created() {
    this.init()
  },
  watch: {
    headerData: {
      deep: true,
      handler(n, o) {
        //接口数据响应改变后修改表格的数据
        if(n.toString() !== o.toString()){
          this.init()
        }
      }
    }
  },
  mounted() {},
  computed: {
    ids() {
      return this.$store.state.states.activeID
    }
  },
  methods: {
    // 初始化数据表格
    init() {
      this.tableData.data = []
      for (let i = 1; i < 100; i++) {
        this.tableHeadY.push(String(i))
        if (i > 1) {
          const td = {
            td: ["", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""]
          }
          this.tableData.data.push(td)
        } else {
          const th = {
            td: ["", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""]
          }
          this.tableData.data.push(th)
        }
      }
      this.headerData.forEach((value, index) => {
        this.tableData.data[0].td[index] = value
      })
      this.listData.forEach((item, i) => {
        item.forEach((value, j) => {
          this.tableData.data[i + 1].td[j] = value
        })
      })
    },
    // 编辑单元格的时候取消选中
    editingTd(trIndex, tdIndex, tdItem) {
      this.select.row = null
      this.select.col = null
      this.editing.row = trIndex
      this.editing.col = tdIndex
      this.editing.value = tdItem
    },
    // 选中单元格的时候取消编辑
    selectTd(trIndex, tdIndex) {
      if (this.editing.row === trIndex && this.editing.col === tdIndex) return
      this.editing.row = null
      this.editing.col = null
      this.editing.value = null
      this.select.row = trIndex
      this.select.col = tdIndex
    },
    // 格式化修改过后的表格数据，规则校验
    formatTableData(data) {
      this.tableX = []
      this.tableY = []
      for (let i = 1; i < data.length; i++) {
        const tr = data[i].td
        for (let j = 0; j < tr.length; j++) {
          const td = tr[j]
          if (j === 0) {
            this.tableX.push(td)
          }
          if (j === 1) {
            this.tableY.push(td)
          }
        }
      }
    },
    getCurrentInputValHandle(value, trIndex, tdIndex) {
      let cloneHeaderData = JSON.parse(JSON.stringify(this.headerData))
      let cloneListData = JSON.parse(JSON.stringify(this.listData))
      if (trIndex === 0) {
        // 修改的表头数据
        cloneHeaderData[tdIndex] = value
        this.$changeOptionsEV(cloneHeaderData, "headerData", false)
        // 只有序号表格才需要同步这个数据
        if (this.options.serialNumberHeaderData) {
          let cloneSerialNumberHeaderData = JSON.parse(JSON.stringify(this.options.serialNumberHeaderData))
          if (tdIndex > cloneSerialNumberHeaderData.length - 1) {
            // 新增数据
            const temp = JSON.parse(JSON.stringify(cloneSerialNumberHeaderData[0]))
            cloneSerialNumberHeaderData.push(temp)
            cloneSerialNumberHeaderData[tdIndex].value = value
          } else {
            // 修改数据
            cloneSerialNumberHeaderData[tdIndex].value = value
          }
          console.log("cloneSerialNumberHeaderData", cloneSerialNumberHeaderData)
          this.$changeOptionsEV(cloneSerialNumberHeaderData, "serialNumberHeaderData", false)
        }
      } else {
        // 新增数据
        if (trIndex - cloneListData.length > 0) {
          let temp = []
          if (cloneListData.length !== 0) {
            temp = new Array(cloneListData[0].length)
          }
          temp[tdIndex] = value
          cloneListData.push(temp)
        } else {
          // 修改数据
          cloneListData[trIndex - 1][tdIndex] = value
        }
        this.$changeOptionsEV(cloneListData, "listData", false)
      }
    },
    // 表格序号和表格内容一起滚动
    scrollTableHandle: _throttle(function (event) {
      let scrollTop = event.target.scrollTop
      let scrollLeft = event.target.scrollLeft
      this.$refs.scrollLeft.style.top = -scrollTop + "px"
      this.$refs.scrollTop.style.left = -scrollLeft + "px"
    }, 10),
    // 选中整行
    selectRow(index) {
      if (index > 0) {
        this.select_index = index
        this.delete_content = "删除行"
        this.delete_placement = "left"
        this.selectCol_left = 0
        this.selectRow_Col = "selectRow"
        this.selectRow_top = 18 + 27 * index
      }
    },
    // 选中整列
    selectCol(index) {
      this.select_index = index
      this.delete_content = "删除列"
      this.delete_placement = "top"
      this.selectRow_top = 0
      this.selectRow_Col = "selectCol"
      this.selectCol_left = 24 + 70 * index
    },
    // 删除行/列
    deleteArea() {
      let cloneHeaderData = JSON.parse(JSON.stringify(this.headerData))
      let cloneListData = JSON.parse(JSON.stringify(this.listData))
      if (this.delete_placement === "top") {
        // 删除整列
        if (cloneHeaderData.length > this.select_index) {
          // 删除下标不能超出数据长度
          cloneHeaderData.splice(this.select_index, 1)
          cloneListData.forEach(item => {
            item.splice(this.select_index, 1)
          })

          this.$changeOptionsEV(cloneHeaderData, "headerData", false)
          this.$changeOptionsEV(cloneListData, "listData", false)
        }
      } else {
        // 删除整行
        if (this.select_index !== 0 && cloneListData.length + 1 > this.select_index) {
          // 不能删除表头，删除下标不能超出数据长度
          cloneListData.splice(this.select_index - 1, 1)
          this.$changeOptionsEV(cloneListData, "listData", false)
        }
      }
      // 删除后关闭选中行列状态
      this.selectRow_Col = ""
    }
  }
}
</script>

<style scoped>
.title500_16_22 {
  color: inherit;
}
.data-source-type {
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}
.data-source-type/deep/ .el-radio {
  margin-bottom: 16px;
}
.data-source-type/deep/ .el-radio__inner {
  background-color: rgba(255, 255, 255, 0);
}
.dataContent {
  font-size: 14px;
  line-height: 22px;
  color: rgba(255, 255, 255, 0.8);
}
.dataSource-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.dataSource-item .link {
  color: var(--themeColor);
  cursor: pointer;
}
.dataUrl-item input {
  width: 252px;
  height: 32px;
  background: #35383f;
  color: rgba(255, 255, 255, 0.2);
}
.dataUrl-item .tips {
  color: var(--fourthTextColor);
}

.dataTableContainer .outline {
  font-size: 12px;
  position: relative;
  z-index: 0;
  margin-top: 10px;
}
.dataTableContainer .content {
  width: 228px;
  height: calc(232px + 18px);
  overflow: hidden;
  /* background-color: #222222;*/
  background-color: var(--dialogBgColor);
  position: relative;
}
.dataTableContainer .content .scrollTop {
  height: 18px;
  width: 204px;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
  overflow: hidden;
  background-color: inherit;
  position: absolute;
  z-index: 44;
  left: 24px;
}
.dataTableContainer .content .scrollTop ul {
  left: 0;
  width: calc(262px * 4);
  height: inherit;
  position: relative;
  text-align: center;
  cursor: pointer;
  margin: 0;
}
.dataTableContainer .content .scrollTop ul li {
  display: block;
  box-sizing: content-box;
  height: 18px;
  width: 68px;
  border: 1px solid var(--borderColorNine);
  float: left;
  position: relative;
  margin: 0 -1px 0 0;
}
.dataTableContainer .content .scrollLeft {
  width: 24px;
  height: 232px;
  background-color: inherit;
  overflow: hidden;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
  float: left;
  position: absolute;
  z-index: 33;
  top: 18px;
}
.dataTableContainer .content .scrollLeft ul {
  top: 0;
  position: relative;
  width: 100%;
  /* background-color: #222222; */
  background-color: var(--dialogBgColor);
  text-align: center;
  letter-spacing: -1px;
  margin: 0;
  cursor: pointer;
}
.dataTableContainer .content .scrollLeft ul li {
  height: 28px;
  line-height: 28px;
  border: 1px solid var(--borderColorNine);
  position: relative;
  margin: 0 -1px -1px 0;
}
.dataTableContainer .content .scrollTable {
  width: 204px;
  height: 232px;
  overflow: scroll;
  position: absolute;
  left: 24px;
  top: 18px;
  z-index: 11;
}
.dataTableContainer .content .scrollTable table {
  border-collapse: collapse;
}
.dataTableContainer .content .scrollTable .cell {
  border: 1px solid #313336;
  border: 1px solid var(--borderColorNine);
  width: 68px;
  height: 26px;
}
.dataTableContainer .content .scrollTable .cell.select {
  background: var(--cellSelectBgColor);
  border: 1px double var(--selectBorderColor);
}
.dataTableContainer .content .scrollTable .cell.editing {
  border: 1px double var(--elTreeActiveColor);
}
.dataTableContainer .content .scrollTable .cell .value-viewer {
  display: block;
  box-sizing: border-box;
  height: 26px;
  line-height: 26px;
  width: inherit;
  text-align: left;
  padding: 0 2px;
  overflow: hidden;
  white-space: nowrap;
}
.dataTableContainer .content .scrollTable .cell .data-editor {
  display: block;
  box-sizing: border-box;
  height: 24px;
  line-height: 24px;
  width: 84px;
  text-align: left;
  padding: 0 2px;
  overflow: hidden;
  white-space: nowrap;
  background: none;
  outline: none !important;
  border: 0;
  color: var(--text);
}
.dataTableContainer .content .selectArea {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 22;
  pointer-events: none;
}
.dataTableContainer .content .selectArea .selectRow {
  width: 228px;
  height: 28px;
  border: 1px solid #095ad9;
  background: rgba(9, 90, 217, 0.3);
  position: absolute;
}
.dataTableContainer .content .selectArea .selectRow .deleteIcon {
  height: inherit;
  width: 14px;
  line-height: 28px;
  right: 0;
  margin-top: -1px;
}
.dataTableContainer .content .selectArea .selectCol {
  width: 68px;
  height: 250px;
  border: 1px solid #095ad9;
  background: rgba(9, 90, 217, 0.3);
  position: absolute;
}
.dataTableContainer .content .selectArea .selectCol .deleteIcon {
  width: inherit;
  height: 14px;
  line-height: 14px;
  margin-left: -1px;
  bottom: 0;
}
.deleteIcon {
  position: absolute;
  background-color: rgba(255, 78, 78, 0.4);
  border: 1px solid #ff4e4e;
  text-align: center;
  font-size: 14px;
  color: #ff4e4e;
  pointer-events: auto;
  cursor: pointer;
}
.deleteIcon i {
  font-size: 12px;
}
.dataTableContainer .topLeft {
  width: 24px;
  height: 18px;
  line-height: 18px;
  text-align: center;
  /* background-color: #222222; */
  background-color: var(--dialogBgColor);
  position: absolute;
  top: 0;
  left: 0;
  z-index: 66;
}
</style>
